export default __webpack_public_path__ + "static/media/page1.1d8a49cc.webp";